export const COMPONENT_NAME = "history-details";
